module.exports = __webpack_public_path__ + "img/fd_180.fec8ec9e.png";